import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import SkeletonDescriptionText from './Skeleton'

import useStyles from './styles'

function DescriptionText({
  descriptionText,
  isDescriptionBlank,
  isInProgress,
  className,
  showSkeleton,
  skeletonClassName
}) {
  const classes = useStyles()

  if (isDescriptionBlank) return null

  return (
    <div className={classnames(classes.descriptionText, className)}>
      {descriptionText ? (
        descriptionText
      ) : showSkeleton ? (
        <SkeletonDescriptionText className={skeletonClassName} isInProgress={isInProgress} />
      ) : null}
    </div>
  )
}

DescriptionText.propTypes = {
  descriptionText: PropTypes.string,
  isDescriptionBlank: PropTypes.bool,
  isInProgress: PropTypes.bool,
  className: PropTypes.string,
  skeletonClassName: PropTypes.string
}

export default DescriptionText
